import { writable, get } from 'svelte/store';


const { subscribe, set, update } = writable({
	chat_messages: 0,
	log_events: 0,
	collections_items: 0,
});


export const bindings = {
	subscribe,
	
	/* pull */
	pull: prop =>
		prop ? get(bindings)[prop] : get(bindings),
	
	/* push */
	push: value =>
		update(self => Object.assign(self, value)),

	/* reset */
	reset: () =>
		update(self => {}),
};
